function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import moduleStyles from '@dtsl/css-links/dist/index.module.css';
import ExternalLink from '@dtsl/icons/dist/icons/react/ExternalLink';

// eslint-disable-next-line react/display-name
const Link = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    variant,
    labelText,
    url,
    className,
    onClick,
    target,
    ...restprops
  } = props;
  const onClickLink = e => {
    if (url === '#') {
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
    }
    onClick(e);
  };
  const linkClass = classNames({
    [moduleStyles['sib-links']]: true,
    [className]: !!className
  });
  const linkTarget = variant === 'external' ? '_blank' : target || '_self';
  return /*#__PURE__*/React.createElement("a", _extends({
    rel: "noreferrer",
    href: url,
    className: linkClass,
    target: linkTarget,
    onClick: onClickLink,
    ref: ref
  }, restprops), labelText, variant === 'external' ? /*#__PURE__*/React.createElement(ExternalLink, null) : null);
});
Link.propTypes = {
  variant: PropTypes.string,
  labelText: PropTypes.string,
  className: PropTypes.string,
  url: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string
};
Link.defaultProps = {
  url: '#',
  labelText: '',
  className: '',
  variant: 'default',
  onClick: () => {},
  target: ''
};
export default Link;